import { Component } from '@angular/core'
import { ProductScope } from '@spartacus/core'
import { CurrentProductService } from '@spartacus/storefront'
import { classificationCodes } from '../../../shared/mb-constants'

@Component({
  selector: 'mb-pdp-infobox-details-antibody',
  templateUrl: './pdp-infobox-details-antibody.component.html',
  styleUrls: ['./pdp-infobox-details-antibody.component.scss']
})
export class PdpInfoBoxDetailsAntibodyComponent {

  constants = classificationCodes
  product$ = this.currentProductService.getProduct(ProductScope.ATTRIBUTES)

  constructor (protected currentProductService: CurrentProductService) {
  }
}
